import { render, staticRenderFns } from "./CandidateCardNew.vue?vue&type=template&id=0ff92ee6&scoped=true"
import script from "./CandidateCardNew.vue?vue&type=script&lang=js"
export * from "./CandidateCardNew.vue?vue&type=script&lang=js"
import style0 from "./CandidateCardNew.vue?vue&type=style&index=0&id=0ff92ee6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff92ee6",
  null
  
)

export default component.exports